import {
  commandButton,
  iconClass
} from "modules/tenants/sections/pros/dashboard/commonDashboardStyles";

import { CompoundButton, FontIcon, IButtonProps } from "@bps/fluent-ui";
import { useCommandRunner } from "../../../../../_shared-context/command-runner-context/command-runner-context";

type SiteCommandButtonProps = Pick<IButtonProps, "onClick" | "menuProps"> & {
  commandName: string;
  iconName: string;
};

export const SiteCommandButton = ({
  commandName,
  iconName,
  ...buttonProps
}: SiteCommandButtonProps) => {
  const commandRunner = useCommandRunner();

  return (
    <CompoundButton
      {...buttonProps}
      disabled={commandRunner.isBusy}
      secondaryText={commandName}
      styles={commandButton}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        }}
      >
        <FontIcon iconName={iconName} className={iconClass} />
        {buttonProps.menuProps ? (
          <div style={{ paddingTop: "5px", paddingLeft: "10px" }}>
            <FontIcon iconName="ChevronDownSmall" />
          </div>
        ) : null}
      </div>
    </CompoundButton>
  );
};
